export default __webpack_public_path__ + "static/media/sc-logo-mobile.a3d08e2c.svg";